import {format} from 'date-fns';

export default function dateTimeUtcNow() {
    const now = new Date();
    const formattedDateTime = format(now, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'");
    return formattedDateTime;
}
